<template>
  <div
    class="categoryPrompt"
    v-if="this.value.hidenShowPrompt"
    :style="{
     //'left': judgeFixed?  windowMove.left + 'px' : (windowMove.left + 290 + 'px'),
     //'left':'boxName==scenes'?362+10+'px':0+'px',
      'top':  (windowMove.top - 3 + (addHeight ? addHeight : 0)) + 'px',

    }"
  >
    <!-- 这里编译不通过暂时注释掉 ...myStyle -->
    <div class="promptBox">
      {{ dataArray[this.value.id].categoryAllData? dataArray[this.value.id].categoryAllData.name : '没有名字' }}
      <span
        @click="closeCategory()"
        class="closeIcon el-icon-close"
      ></span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  model: {
    prop: "value", //绑定的值，通过父组件传递
    event: "updateCategoryPrompt" //自定义事件名
  },
  props: {
    value: null,
    windowMove: null,
    judgeFixed: null,
    boxName: null,
    dataArray: null,
    addHeight: null
    // 'myStyle': {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  data() {
    return {
      judgebox: true
    };
  },
  watch: {
    "value.hidenShowPrompt": function(val, oldval) {
      // 关键词搜索事件
    }
  },
  mounted() {},
  methods: {
    closeCategory() {
      this.$bus.emit("categoryPromptBox_vue", {
        id: this.value.id,
        boxName: this.boxName
      });
    }
  },
  components: {},
  computed: {
    ...mapGetters(["MaterialPane_Size"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.categoryPrompt {
  position: fixed;
  top: 0;
  // left: 0;
  z-index: 160;
  width: 270px;
  height: 40px;
  padding: 2px 0;
  color: #7d97ff;

  .promptBox {
    position: relative;
    background: rgba(0, 0, 0, 0.8);
    width: 100%;
    height: 40px;
    border-radius: 8px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
    line-height: 40px;

    .closeIcon {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      font-size: 19px;
      text-align: center;
      line-height: 21px;
      border-radius: 10px;
      cursor: pointer;
      background: rgba(0, 0, 0, 0);
      color: #fff;
      transition: all 0.32s;

      &:hover {
        background: #fff;
        color: #000;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/search/categoryPrompt.vue